<template>
  <div class="indexMapList">
      
      <img v-if="btnFlag" style="position:absolute;right:10px;top:90px;height:40px;width:40px;z-index:999999999;" id="go-top" :src="require('./img/top.png')" @click="backTop">

      <!-- 红色龙江弹窗 -->
      <div v-if="popupVisibleLongjiang" class="leaflet-popup  leaflet-zoom-animated" style="opacity: 1;top: 33px;left: 7px;z-index:1;width:calc(100% - 14px);height:370px;">
        <div class="leaflet-popup-content-wrapper">
          <div class="leaflet-popup-content">
              <div style="height:10px;"></div>
              <!-- <mt-search v-model="searchLongjiangValue" placeholder="搜索">
              </mt-search> -->
              <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" infinite-scroll-immediate-check="false">
                  <div v-for="item in longjiangPlaces" style="margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
                    <p @click="locationLongjiang(item)" style="margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-weight:bold;color:red;font-size:16px;">{{ item.placename }}</span></p>
                    <img class="abc" @click="goVR(item)" :src="item.imgurl" alt="" style="width:100%;" v-bind:style="{ height: heightSize + 'px' }">
                  </div>
                </ul>

              <div style="height:40px;"></div>
          </div>
        </div>

        <!-- <div class="leaflet-popup-tip-container">
          <div class="leaflet-popup-tip"></div>
        </div> -->

        <!-- <a class="leaflet-popup-close-button" href="#close" @click="showListLongjiang">
          ×
        </a> -->
      </div>

  </div>
</template>

<script>
import openUrl from "./../utils/openUrl";
// import IndexApi from "../api/learingInd.js";
import cfg from "./../utils/config";
import Vue from "vue";
import L from "leaflet";
import axios from "axios";
import Addr from "./../utils/getAPI";

export default {
  name: "indexMapList",
  data() {
    return {
      searchLongjiangValue:"",
      btnFlag: false, //回到顶部
      mapLongjiang: null,
      mapChina: null,
      popupVisibleLongjiang: true,
      heightSize: 160,
      allLongjiangPlaces:[],
      // longjiangPlaces: [
      //   {
      //     id: 0,
      //     imgurl: require("./img/history.jpg"),
      //     lat: 39.9054446409,
      //     lon: 116.4014427338,
      //     level: 0,
      //     placename: "哈尔滨医科大学校史纪念馆",
      //     yunurl: "https://beyond.3dnest.cn/play/index.html?m=577cfd1a_DeU4_b6f9&o=1"
      //   },
      //   {
      //     id: 0,
      //     imgurl: require("./img/wuhouse.jpg"),
      //     lat: 45.3369055256,
      //     lon: 131.0113323927,
      //     level: 1,
      //     placename: "伍连德纪念馆",
      //     yunurl: "http://beyond.3dnest.cn/play/?m=ac6bc9d2_1Va5_b6f9&from=groupmessage&isappinstalled"
      //   }
      // ]
      // longjiangPlaces: [
      //   {
      //     id: 0,
      //     imgurl: require("./img/huabei.png"),
      //     lat: 46.60792075653775,
      //     lon: 124.8801291547716,
      //     level: 0,
      //     placename: "华北革命战争纪念馆",
      //     yunurl: "https://beyond.3dnest.cn/play/?m=hb_lsly"
      //   },
      //   {
      //     id: 0,
      //     imgurl: require("./img/gutian.jpg"),
      //     lat: 46.58162907799555,
      //     lon: 125.14610085636379,
      //     level: 1,
      //     placename: "古田会议旧址",
      //     yunurl: "http://beyond.3dnest.cn/play/?m=zq_gthyjz_25"
      //   },
      //   {
      //     id: 0,
      //     imgurl: require("./img/xibaipo.jpg"),
      //     lat: 46.58162907799555,
      //     lon: 125.14610085636379,
      //     level: 1,
      //     placename: "西柏坡廉政教育馆",
      //     yunurl: "https://beyond.3dnest.cn/play/?m=xbp_lz"
      //   },
      // ]
    };
  },
  methods: {
    //vue 回到顶部 https://blog.csdn.net/qq_36070288/article/details/84765139
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      let that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 60) {
        // console.log("scrollTop is"+that.scrollTop);
        //动态改变回到顶部按钮的位置
        if (document.getElementById("go-top")) {
          document.getElementById("go-top").style.top =
            that.scrollTop + 350 + "px";
        }
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    locationLongjiang(item) {
      this.mapLongjiang.setView([item.lat, item.lon], 14);
      this.showListLongjiang();
    },
    locationChina(item) {
      this.mapChina.setView([item.lat, item.lon], 9);
      this.showListChina();
    },
    showListChina() {
      console.log("showListChina");
      this.popupVisibleChina = !this.popupVisibleChina;
    },
    showListLongjiang() {
      console.log("showListLongjiang");
      this.popupVisibleLongjiang = !this.popupVisibleLongjiang;
    },
    setSize() {
      //1 index-map-list
      if (document.getElementById("map-container-longjiang")) {
        //设置地图高度
        document.getElementById("map-container-longjiang").style.height =
          window.innerHeight - 128 + "px"; //167
      }
      if (document.getElementById("map-container-china")) {
        //设置地图高度
        document.getElementById("map-container-china").style.height =
          window.innerHeight - 128 + "px"; //167
      }
    },
    goVR(place) {
      if(place.yunurl==""){
        return;
      }
      //window.location.href = place.yunurl;
      openUrl.openInExplorer(place.yunurl);
    },
    loadMore() {
      this.loading = true;
      setTimeout(() => {
        // let last = this.list[this.list.length - 1];
        // for (let i = 1; i <= 10; i++) {
        //   this.list.push(last + i);
        // }
        this.loading = false;
      }, 2500);
    },
    init: function() {
      
    },
    // 首页搜索
    goSeach: function() {
      this.$router.push({ path: "/search/" });
    },
    // 搜索处理
    onblurEvent: function() {
      if (this.searchName === "") {
        this.seachWt = "65px";
      } else {
        this.seachWt = "90%";
      }
    },
    focusEvent: function() {
      this.seachWt = "90%";
    }
  },
  watch: {
    searchLongjiangValue: function(newVal, oldVal) {
      console.log("longjiang change");
      console.log(oldVal);
      console.log(newVal);
      if(newVal==""){
        this.longjiangPlaces=this.allLongjiangPlaces;
      }else{
        this.longjiangPlaces=this.allLongjiangPlaces.filter(item => item.placename.indexOf(newVal)!=-1);
      }
      
    },
    searchChinaValue: function(newVal, oldVal) {
      console.log("china change");
      console.log(oldVal);
      console.log(newVal);
      if(newVal==""){
        this.places=this.allPlaces;
      }else{
        this.places=this.allPlaces.filter(item => item.placename.indexOf(newVal)!=-1);
      }
    },
    selected: function(oldVal, newVal) {
      console.log(newVal);
      if (newVal == 1) {
        this.popupVisibleLongjiang = false;
        //leaflet地图在选项卡中不正常显示  http://www.bubuko.com/infodetail-1905601.html
        L.Util.requestAnimFrame(
          this.mapChina.invalidateSize,
          this.mapChina,
          !1,
          this.mapChina._container
        );
      }
      if (newVal == 2) {
        this.popupVisibleChina = false;
        //leaflet地图在选项卡中不正常显示  http://www.bubuko.com/infodetail-1905601.html
        L.Util.requestAnimFrame(
          this.mapLongjiang.invalidateSize,
          this.mapLongjiang,
          !1,
          this.mapLongjiang._container
        );
      }
    }
  },
  destroyed() {
    //回到顶部
    window.removeEventListener("scroll", this.scrollToTop);
  },
  mounted: function() {
    //回到顶部
    window.addEventListener("scroll", this.scrollToTop);

    window.addEventListener("resize", () => {
      this.setSize();
    });

    this.setSize();

    if (window.innerWidth > cfg.widthLimit) {
      this.heightSize = 200;
    }

    this.init();

    // console.log("route is:");
    // console.log(this.$route.fullPath);
    var that = this;
try {
      mui.plusReady(function() {
        // //首页返回键处理
        // //处理逻辑：1秒内，连续两次按返回键，则退出应用；
        var first = null;
        mui.back = function() {
          //首次按键，提示  再按一次退出应用
          if (!first) {
            if (
              that.$route.fullPath == "/index" ||
              that.$route.fullPath == "/list" ||
              that.$route.fullPath == "/course" ||
              that.$route.fullPath == "/my"
            ) {
              first = new Date().getTime(); //记录第一次按下回退键的时间
              mui.toast("再按一次退出应用"); //给出提示
            } else {
              history.go(-1); //回退到上一页面
            }
  
            setTimeout(function() {
              //1s中后清除
              first = null;
            }, 1000);
          } else {
            if (new Date().getTime() - first < 1000) {
              //如果两次按下的时间小于1s，
              plus.runtime.quit(); //那么就退出app
            }
          }
        };
      });
} catch (error) {
  console.log(error)
}
  }
};
</script>

<style lang="scss">
@import "../assets/baseScss";
@media screen and (min-width: 800px) { 
  .abc {height: 500px!important}  
}
//
a.leaflet-popup-close-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 4px 0 0;
  border: none;
  text-align: center;
  width: 18px;
  height: 14px;
  font: 16px/14px Tahoma, Verdana, sans-serif;
  color: #c3c3c3;
  text-decoration: none;
  font-weight: bold;
  background: transparent;
}
//隐藏放大缩小
.leaflet-left {
  display: none;
}

.mint-navbar .mint-tab-item.is-selected {
  color: #e70202 !important;
  border-bottom: 2px solid #e70202 !important;
}

.indexHeader {
  height: 200px;
  position: relative;
}
.indexHeader {
  .search {
    position: absolute;
    z-index: 99;
    width: 90%;
    left: 5%;
    top: 10px;
    background: rgba(255, 255, 255, 0.9);
    color: $cl4;
    line-height: 35px;
    input {
      height: 35px;
      width: 65px;
      line-height: 35px;
      background: transparent;
      border: none;
      font-size: 16px;
      padding: 0 1px;
    }
    input:focus {
      outline: medium;
      width: 85%;
    }
    i:before {
      position: relative;
      font-size: 16px;
      top: 1px;
      left: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index-map-list.vue